import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { MacroLinkSuccessAction, MacroLinkFailedAction, MacroLinkLoadingAction, MacroLinkAction } from './actions';
import { MacroLinkState, initialMacroLinkState, initialMacroLinkStateBySymbol } from './state';

const macroLinkSlice = createSlice({
  name: 'macro-link',
  initialState: initialMacroLinkState,
  reducers: {
    reset: () => initialMacroLinkState,
    loading: (state: MacroLinkState, action: PayloadAction<MacroLinkLoadingAction>) => {
      state[action.payload.symbol] = {
        error: undefined,
        loading: action.payload.loading,
        loaded: !action.payload.loading,
        links: state[action.payload.symbol]?.links ?? []
      };
    },
    success: (state: MacroLinkState, action: PayloadAction<MacroLinkSuccessAction>) => {
      state[action.payload.symbol] = {
        error: undefined,
        loading: false,
        loaded: true,
        links: action.payload.links
      };
    },
    fail: (state: MacroLinkState, action: PayloadAction<MacroLinkFailedAction>) => {
      state[action.payload.symbol] = {
        error: action.payload.error,
        loading: false,
        loaded: true,
        links: state[action.payload.symbol]?.links ?? []
      };
    },
    add: (state: MacroLinkState, action: PayloadAction<MacroLinkAction>) => {
      const current = state[action.payload.symbol] ?? { ...initialMacroLinkStateBySymbol, symbol: action.payload.symbol };
      current.links.push(action.payload.link);
      current.loaded = true;
      current.loading = false;
      current.error = undefined;
    },
    update: (state: MacroLinkState, action: PayloadAction<MacroLinkAction>) => {
      const current = state[action.payload.symbol] ?? { ...initialMacroLinkStateBySymbol, symbol: action.payload.symbol };
      const link = action.payload.link;
      const item = current.links.find((x) => x.id === link.id);
      const index = item ? current.links.indexOf(item) : -1;
      current.links[index] = { ...link };
      current.loaded = true;
      current.loading = false;
      current.error = undefined;
    },
    remove: (state: MacroLinkState, action: PayloadAction<MacroLinkAction>) => {
      const current = state[action.payload.symbol] ?? { ...initialMacroLinkStateBySymbol, symbol: action.payload.symbol };
      const link = action.payload.link;
      const item = current.links.find((x) => x.id === link.id);
      const index = item ? current.links.indexOf(item) : -1;
      current.links.splice(index, 1);
      current.loaded = true;
      current.loading = false;
      current.error = undefined;
    }
  }
});

const { actions, reducer } = macroLinkSlice;
export const { reset, loading, success, fail, add, update, remove } = actions;
export default reducer;
